import { Palette } from '@common/theming/Palette';
import React from 'react';
import { AssetBlockProps } from '../../pages/AssetApp';
import { TextBlock } from '../TextBlock';
import InfoTable from './InfoTable';
import ProfileAssetHeading from './ProfileAssetHeading';

const LocationInfo: React.FC<AssetBlockProps> = ({ asset }) => {
  return (
    <div>
      <ProfileAssetHeading heading={asset.locationInfo?.heading} />
      <div style={{ marginTop: 20 }}>
        <InfoTable rows={asset.locationInfo?.rows || []} field="locationInfo" />
      </div>
      <TextBlock size={12} style={{ color: Palette.WHITE_70, marginLeft: 5, marginTop: 12 }}>
        {asset.locationInfo?.disclaimer}
      </TextBlock>
    </div>
  );
};

export default LocationInfo;
